import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mx-auto" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

import { onMounted, ref } from 'vue'
import { loadStripe } from '@stripe/stripe-js'
import { trackEvent } from '@/shared'


export default /*@__PURE__*/_defineComponent({
  __name: 'UpgradeToProCheckout',
  props: {
  stripeKey: String,
  clientSecret: { type: String, default: 'monthly' },
  plan: String,
  open: Boolean
},
  setup(__props) {

const props = __props

const checkoutContainer = ref<HTMLElement | null>(null)
const isFetchingSession = ref(true)
const stripePromise = loadStripe(props.stripeKey)

onMounted(async () => {
  isFetchingSession.value = false
  const stripe = await stripePromise
  if (!stripe || !checkoutContainer.value) return

  // 1) Prepare the observer *before* mount
  const observer = new MutationObserver((mutations, obs) => {
    for (const m of mutations) {
      for (const node of Array.from(m.addedNodes)) {
        if (node instanceof HTMLIFrameElement) {
          node.setAttribute('title', 'Stripe Embedded Checkout')
          obs.disconnect()
          return
        }
      }
    }
  })
  observer.observe(checkoutContainer.value, { childList: true, subtree: true })

  // 2) Mount the embedded checkout
  const checkout = await stripe.initEmbeddedCheckout({
    clientSecret: props.clientSecret
  })
  checkout.mount(checkoutContainer.value)

  // 3) If it was injected synchronously, patch it now
  const immediateFrame = checkoutContainer.value.querySelector<HTMLIFrameElement>('iframe')
  if (immediateFrame) {
    immediateFrame.setAttribute('title', 'Stripe Embedded Checkout')
    observer.disconnect()
  }

  // 4) Analytics
  trackEvent('upgrade_started', { plan: props.plan }, true, false)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isFetchingSession.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _cache[0] || (_cache[0] = [
          _createElementVNode("p", null, "Loading checkout...", -1)
        ])))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", {
            ref_key: "checkoutContainer",
            ref: checkoutContainer,
            id: "checkout-container",
            class: "py-8 bg-white border shadow-lg border-clay-500 rounded-2xl"
          }, null, 512)
        ]))
  ]))
}
}

})